module.exports = __webpack_public_path__ + "img/scene-commercial.28a3fc35.jpg";